import { DataRequirements } from '../data.requirements';
import * as i0 from "@angular/core";
import * as i1 from "../mappers/teacher-list.mapper";
import * as i2 from "../data.requirements";
export class TeacherListUseCase {
    constructor(mapper, data) {
        this.mapper = mapper;
        this.data = data;
    }
    run() {
        return this.data.getTeacherList().pipe(this.mapper.map);
    }
}
TeacherListUseCase.ngInjectableDef = i0.ɵɵdefineInjectable({ factory: function TeacherListUseCase_Factory() { return new TeacherListUseCase(i0.ɵɵinject(i1.TeacherListMapper), i0.ɵɵinject(i2.DataRequirementsInjectionToken)); }, token: TeacherListUseCase, providedIn: "root" });
